import { render, staticRenderFns } from "./BaseLoadingAllScreen.vue?vue&type=template&id=0a45ef45&scoped=true&"
import script from "./BaseLoadingAllScreen.vue?vue&type=script&lang=js&"
export * from "./BaseLoadingAllScreen.vue?vue&type=script&lang=js&"
import style0 from "./BaseLoadingAllScreen.vue?vue&type=style&index=0&id=0a45ef45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a45ef45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a45ef45')) {
      api.createRecord('0a45ef45', component.options)
    } else {
      api.reload('0a45ef45', component.options)
    }
    module.hot.accept("./BaseLoadingAllScreen.vue?vue&type=template&id=0a45ef45&scoped=true&", function () {
      api.rerender('0a45ef45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseLoadingAllScreen.vue"
export default component.exports